const tagLabelVariants = {
    _betStatus: {
        root: {
            $extendFromVariant: "default",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "3px 6px",
            borderRadius: "4px",
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "16px",
            textTransform: "uppercase",
            height: "22px",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            whiteSpace: "nowrap",
        },
    },
    _combinationStatus: {
        root: {
            display: "inline-block",
            width: "20px",
            height: "20px",
            marginRight: "1px",
            textAlign: "center",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "20px",
        }
    },
    _bonusLabel: {
        root: {
            marginTop: 0,
            marginLeft: 0,
            marginRight: "auto",
            marginBottom: "$s2",
            paddingTop: "3px",
            paddingRight: "6px",
            paddingBottom: "3px",
            paddingLeft: "6px",
            borderRadius: "4px",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "14px",
            textTransform: "uppercase",
        }
    },
    boostInelligible: {
        root: {
            position: "relative",
            marginTop: 0,
            marginLeft: 0,
            marginRight: "auto",
            marginBottom: "12px",
            paddingTop: "8px",
            paddingRight: "5px",
            paddingBottom: "5px",
            paddingLeft: "5px",
            color: "$gray300",
            backgroundColor: "$gray700",
            textTransform: "uppercase",
        }
    },
    CombinationOpen: {
        $extendFromVariant: "_combinationStatus",
        root: {
            color: "$white",
            backgroundColor: "$gray700",
        }
    },
    CombinationLost: {
        $extendFromVariant: "_combinationStatus",
        root: {
            color: "$black",
            backgroundColor: "$red400",
        }
    },
    CombinationVoid: {
        $extendFromVariant: "_combinationStatus",
        root: {
            color: "$black",
            backgroundColor: "$gray400",
        }
    },
    CombinationWon: {
        $extendFromVariant: "_combinationStatus",
        root: {
            color: "$black",
            backgroundColor: "$green400",
        }
    },
    Cancelled: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$white",
            backgroundColor: "rgba(255, 255, 255, 0.07)",
        }
    },
    CashOut: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$green400",
            backgroundColor: "rgba(83, 211, 55, 0.07)",
        }
    },
    freeBet: {
        $extendFromVariant: "_bonusLabel",
        root: {
            color: "$green400",
            backgroundColor: "$green900",
            marginRight: "0",
            marginBottom: "0",
        }
    },
    Open: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$yellow400",
            backgroundColor: "rgba(247, 208, 2, 0.07)",
        }
    },
    Lost: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$white",
            backgroundColor: "rgba(255, 255, 255, 0.07)",
        }
    },
    Void: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$white",
            backgroundColor: "rgba(255, 255, 255, 0.07)",
        }
    },
    Won: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$green400",
            backgroundColor: "rgba(83, 211, 55, 0.07)",
        }
    },
    GhostWin: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$green400",
            backgroundColor: "rgba(83, 211, 55, 0.07)",
        }
    },
    EarlyExit: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "#F3601B",
            backgroundColor: "rgba(243, 96, 27, 0.16)",
        }
    },
    EarlyExitWin: {
        $extendFromVariant: "_betStatus",
        root: {
            color: "$green400",
            backgroundColor: "rgba(83, 211, 55, 0.07)",
        }
    },
    sgp: {
        root: {
            display: "inline-block",
            marginRight: "8px",
            paddingTop: "2px",
            paddingRight: "4px",
            paddingBottom: "2px",
            paddingLeft: "4px",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "$green400",
            borderRadius: "2px",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "10px",
            lineHeight: "11px",
            color: "$green400",
            backgroundColor: "$green900",
            textTransform: "uppercase",
        }
    },
    sgpExtra: {
        $extendFromVariant: "sgp",
        root: {
            textTransform: "none",
        }
    },
    replay: {
        $extendFromVariant: "sgp",
    },
};
export { tagLabelVariants };
//# sourceMappingURL=tagLabel.js.map